import React, { ReactNode } from 'react';
import { FaRegEdit, FaTrash } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import BtnTable from '../buttons/BtnTable';
import { FaFileCircleCheck } from 'react-icons/fa6';

const CardButtonEdit = ({
  title,
  children,
  background,
  
}) => {

  const navigate = useNavigate()


  return (
    <div 
      className={`${background} rounded-md border border-stroke pt-6 px-7.5 shadow-sm shadow-green-400 dark:border-strokedark dark:bg-boxdark`}>
      <h1 className='text-center  uppercase font-bold p-3 '>{title}</h1>
      <div className="my-4 flex h-18 items-center justify-center dark:bg-meta-4">
        <FaFileCircleCheck size={60} className='text-green-500' />
      </div>
      <div className='flex gap-1 justify-end items-center h-[50px] p-2 border-t-2 '>
        {children}
      </div>
    </div>
  );
};

export default CardButtonEdit;
